/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Huu Khang Nguyen
 * Created: 03/02/22
 */

import {
    withCurrentAssignment,
    WithCurrentAssignmentProps,
} from '@/components/contexts/AssignmentContext/withCurrentAssignment';
import WorkplanSummaryProvider from '@/components/contexts/WorkplanSummaryContext/WorkplanSummaryProvider';
import ItemsTile from '@/components/pages/dashboard/tiles/ItemsTile/ItemsTile';
import { Grid, GridItem } from '@chakra-ui/react';
import React from 'react';
import { useParams } from 'react-router-dom';
import WorkplanLeaveTile from '@/components/pages/dashboard/tiles/LeaveTile/WorkplanLeaveTile';
import { WorkplanIdProvider } from '@/components/contexts/WorkplanContext/providers';
import WorkplanAllocationsTile from '../dashboard/tiles/ChartTile/WorkplanAllocationsTile';
import ReviewTile from '@/components/pages/dashboard/tiles/ReviewTile/ReviewTile';
import ButtonActionTile from '../dashboard/tiles/ButtonTile/ButtonActionTile';
import { CurrentWorkplanHeader } from '@/components/Header/CurrentWorkplanHeader';
import WorkplanVersionProvider from '@/components/contexts/VersionContext/WorkplanVersionProvider';
import WorkplanSupervisorsTile from '@/components/pages/dashboard/tiles/SupervisorTile/WorkplanSupervisorsTile';
import { DashboardHeaderTile } from '@/components/Header/DashboardHeaderTile';
import { MySummaryHeading } from '@/components/pages/dashboard/MySummaryHeading';
import WorkplanEOYRatingTile from '@/components/pages/dashboard/tiles/WorkplanEOYRatingTile/WorkplanEOYRatingTile';

const NewWorkplan = ({ currentAssignment }: WithCurrentAssignmentProps) => {
    const { id, version } = useParams<{
        id: string;
        version: string;
    }>();

    return (
        <WorkplanIdProvider id={Number(id && id)}>
            <WorkplanVersionProvider version={version ? Number.parseInt(version) : undefined}>
                <WorkplanSummaryProvider>
                    <Grid w={'100%'} templateColumns={'repeat(2, 1fr)'} gap={6} p={6}>
                        <CurrentWorkplanHeader />
                        <DashboardHeaderTile heading />
                        <GridItem colSpan={2}>
                            <MySummaryHeading />
                        </GridItem>
                        <GridItem colSpan={{ base: 2, lg: 1 }}>
                            <Grid gap={6} templateRows={'0.5fr 1.5fr'} h={'100%'}>
                                <WorkplanSupervisorsTile />
                                <WorkplanLeaveTile />
                            </Grid>
                        </GridItem>
                        <WorkplanAllocationsTile />
                        <ItemsTile />
                        <WorkplanEOYRatingTile assignment={currentAssignment} />
                        <ReviewTile assignment={currentAssignment} />
                        <ButtonActionTile assignment={currentAssignment} />
                    </Grid>
                </WorkplanSummaryProvider>
            </WorkplanVersionProvider>
        </WorkplanIdProvider>
    );
};

export default withCurrentAssignment(NewWorkplan);
